export const cardData=[
  {
      id:1,
      label:'All Users',
      count: 844937,
      icon:'/assets/media/cards/all users.svg',
      bgcolor:'#c8d7a8',
      type: ["All"],
      loading: false,
  },
  {
    id:2,
    label:'Web Users',
    count: 844937,
    icon:'/assets/media/cards/web.svg',
    bgcolor:'#c8d7a8',
   type: ["All", "Web"],
   loading: false,
},
{
  id:3,
  label:'Active Web Users logged in within 30 days',
  count: 272,
  icon:'/assets/media/cards/web active.svg',
  bgcolor:'#c8d7a8',
   type:["All","Web"],
   loading: false,
},
{
  id:4,
  label:'Mobile Users',
  count: 30,
  icon:'/assets/media/cards/mobile.svg',
  bgcolor:'#c8d7a8',
  type:["All","Mobile"], 
  loading: false,

 
},
{
  id:5,
  label:'Active Mobile Users logged in within 30 days',
  count: 0,
  icon:'/assets/media/cards/mobile active.svg',
  bgcolor:'#c8d7a8',
  type:["All","Mobile"],
  loading: false,
 
},
{
  id:6,
  label:'Total Enterprises',
  count: 26,
  icon:'/assets/media/cards/enterprise.svg',
  bgcolor:'#c8d7a8',
  type:["All","Enterprise"],
  loading: false,
 
},
{
  id:7,
  label:'Enterprise Users',
  count: 52,
  icon:'/assets/media/cards/total farmers.svg',
  bgcolor:'#c8d7a8',
  type:["All","Enterprise"],
  loading: false,
 
},
{
  id:8,
  label:'Total Farms',
  count:3563,
  icon:'/assets/media/cards/total farms.svg',
  bgcolor:'#c8d7a8',
  type:["All","Enterprise"],
  loading: false,
 
},
{
  id:9,
  label:'Total Paid Farms',
  count: 179,
  icon:'/assets/media/cards/farms.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
{
  id:10,
  label:'Total Unpaid Farms',
  count: 100,
  icon:'/assets/media/cards/farms.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
{
  id:11,
  label:'Total Farm Area',
  count: 158811.98,
  icon:'/assets/media/cards/total area.svg',
  bgcolor:'#c8d7a8',
  type:["All","Enterprise"],
  loading: false,
 
},

{
  id:12,
  label:'Total Enquiries',
  count: 30,
  icon:'external-drive',
  bgcolor:'#CDC1FF',
  type:["Addon"],
  loading: false,
 
},
{
  id:13,
  label:'Total Active Users',
  count: 100,
  icon:'/assets/media/cards/all users.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
{
  id:14,
  label:'Total Inactive Users',
  count: 100,
  icon:'/assets/media/cards/all users.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
{
  id:14,
  label:'Total Paid Users',
  count: 150,
  icon:'/assets/media/cards/all users.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
{
  id:15,
  label:'Total Unpaid Users',
  count: 160,
  icon:'/assets/media/cards/all users.svg',
  bgcolor:'#c8d7a8',
  type:["All"],
  loading: false,
 
},
]